export default __webpack_public_path__ + "static/media/loading-chain.5976b7c5.gif";